import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { FormBaseComponent } from '@anihis/shared/src/shared/base-components/form-base.component';
import { inject } from '@angular/core';

@Component({
  selector: 'anihis-owner-statement-euthanasia',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    TranslocoModule,
  ],
  templateUrl: './owner-statement-euthanasia.component.html',
  styleUrls: ['./owner-statement-euthanasia.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OwnerStatementEuthanasiaComponent
  extends FormBaseComponent
  implements OnInit
{
  @Output() formChange = new EventEmitter<any>();

  override ngOnInit(): void {
    this.form = this.fb.group({
      justification: [''],
      veterinarianName: [''],
    });

    this.formChange.emit(this.form.value);
    this.subs.sink = this.form.valueChanges.subscribe((v) =>
      this.formChange.emit(v),
    );

    super.ngOnInit();
  }
}
